var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M24 2h-5V.5a.5.5 0 1 0-1 0V2H7V.5a.5.5 0 0 0-1 0V2H1a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h23a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm0 21H1V8h23v15Zm0-16H1V3h23v4Z"
})));
export default SvgCalendar;